import React from "react";

import { RiEdit2Fill } from "@react-icons/all-files/ri/RiEdit2Fill";
import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";

function Chapter({
  setSlicingEmptyObjects,
  setNotChapter,
  index,
  setAddChap,
  setIndexOfChap,
  novelChaps,
  novelData,
  setChapterPopup,
}) {
  function handleClick() {
    let titleRule = novelData.title.trim();
    if (titleRule.length < 5 || titleRule.length > 40) {
      setChapterPopup(true);
      setTimeout(() => {
        setChapterPopup(false);
      }, 2000);
    } else {
      setSlicingEmptyObjects(false);
      setAddChap(true);
      // we give him our current index so he can
      // show data of that specific index
      setIndexOfChap(index);
    }
  }
  function clear() {
    // we delete using the index
    // we are IN
    // in our .map
    novelChaps.splice(index, 1);
    setNotChapter(
      0,
      setTimeout(() => {
        setNotChapter(5);
      }, 2000)
    );
  }

  return (
    <div>
      <div className="w-full flex flex-col  gap-y-2 md:gap-y-2">
        <div className="flex group h-[52px] w-full">
          <div
            onClick={handleClick}
            className=" cursor-pointer w-[70%] sm:w-[70%] md:w-[80%] lg:w-[90%] h-full bg-tertiary group-hover:bg-tertiary/90 duration-500 ease-in-out flex justify-between items-center"
          >
            <h2 className="capitalize px-4 md:px-8 text-[13px] sm:text-[16px]">
              Chapter {index + 1}
            </h2>
          </div>
          <div className="w-[50%] sm:w-[30%] md:w-[20%] lg:w-[10%]  flex space-x-2">
            <div onClick={handleClick} className="w-full h-full cursor-pointer">
              <div className="w-full text-tertiary h-full bg-primary group-hover:bg-primary/90 duration-500 ease-in-out flex justify-center items-center">
                <RiEdit2Fill />
              </div>
            </div>
            <div onClick={clear} className="cursor-pointer w-full">
              <div className="w-full h-full bg-error hover:bg-error/80 duration-500 ease-in-out flex justify-center items-center  ">
                <AiOutlinePlus className="rotate-45 text-tertiary scale-125" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Chapter;
